import PubSub from "underpub-js";
import {
  gsap
} from "gsap";
import {
  MorphSVGPlugin
} from "gsap/MorphSVGPlugin.js";

var Cursor = function (options) {

  this.options = {
    $el: false,
    baseClass: 'atom-Cursor',
  };

  $.extend(true, this.options, options);

};

Cursor.prototype.init = function () {

  var self = this;

  this.clientX = -100;
  this.clientY = -100;
  this.previousClientX = -100;
  this.previousClientY = -100;

  this.$body = $("body");
  this.$cursor = this.options.$el;
  this.$innerCursor = this.options.$el.find(`.${self.options.baseClass}__inner`);
  this.$outerCursor = this.options.$el.find(`.${self.options.baseClass}__outer`);

  // register svg morph gsap plugin
  gsap.registerPlugin(MorphSVGPlugin);

  // morph cursor svg to use path
  MorphSVGPlugin.convertToPath(self.$innerCursor.find('circle, polygon'));

  // this needs to be done after converting the SVG to path
  this.$innerCursorSvg = this.options.$el.find(`.${self.options.baseClass}__inner #cursor-default-dot`);

  // set up our hover targets
  this.hoverTargets = [{
      "selector": ".cursor-left-arrow",
      "hoverClass": `${self.options.baseClass}--leftArrow`,
      "cursorSvgShapeId": "#cursor-arrow-left"

    },
    {
      "selector": ".cursor-right-arrow",
      "hoverClass": `${self.options.baseClass}--rightArrow`,
      "cursorSvgShapeId": "#cursor-arrow-right"
    },
  ];

  this.initCursor();
  this.handleCursorHover();

};

// set up mouse enter and leave events that will trigger cursor changes
Cursor.prototype.handleCursorHover = function () {

  var self = this;

  // for each target
  for (var i = 0; i < self.hoverTargets.length; i++) {

    // get our targets and hoverClass that will be used in mouse enter/leave functions
    let $targets = $(self.hoverTargets[i].selector)
    let hoverClass = self.hoverTargets[i].hoverClass;
    let svgShapeId = self.hoverTargets[i].cursorSvgShapeId;

    $targets.on('mouseenter', function () {
      self.options.$el.addClass(hoverClass);
      gsap.fromTo(self.$innerCursorSvg, {
        morphSVG: self.$innerCursor.find('#cursor-default-dot')
      }, {
        duration: 0.3,
        morphSVG: self.$innerCursor.find(svgShapeId)
      });
    });

    $targets.on('mouseleave', function () {
      self.options.$el.removeClass(hoverClass);
      gsap.to(self.$innerCursorSvg, {
        duration: 0.3,
        morphSVG: self.$innerCursor.find('#cursor-default-dot')
      });
    });


  }

};

Cursor.prototype.initCursor = function () {

  var self = this;

  // add our class that hides the default cursor
  this.$body.addClass('custom-cursor');

  // on each mousemove event, update our X/Y variables
  document.addEventListener("mousemove", e => {
    self.clientX = e.clientX;
    self.clientY = e.clientY;
  });

  // run render before next browser repaint
  // we're binding the current value of this, so that this will point to the proper object in render
  requestAnimationFrame(self.render.bind(this));

};

// render function that will be called each time the browser repaints
Cursor.prototype.render = function () {

  var self = this;

  // checking this prevents continuing to run tweens when cursor is at rest (this was causing some weird effects)
  if (self.clientX != self.previousClientX || self.clientY != self.previousClientY) {

    // immediately move inner cursor
    gsap.set(self.$innerCursor, {
      x: self.clientX,
      y: self.clientY
    });

    gsap.set(self.$outerCursor, {
      x: self.clientX,
      y: self.clientY
    });

    // set a tween so that outer cursor lags
    // gsap.to(self.$outerCursor, {
    // 	duration: .4,
    // 	delay: .05,
    // 	x: self.clientX,
    // 	y: self.clientY,
    // 	ease: "expo.easeout"
    // });

    self.previousClientX = self.clientX;
    self.previousClientY = self.clientY;

  }

  // run render again before next browser repaint
  // we're binding the current value of this, so that this will point to the proper object in next call to render
  requestAnimationFrame(self.render.bind(self));

};

export default Cursor;